/* src/app/shared/components/lead-details-address/lead-details-address.component.css */
input:read-only {
  cursor: default;
  background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
  color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
}
.manual-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
.manual-toggle input {
  height: 16px;
  margin-right: 12px;
  width: inherit;
}
.search-address {
  margin-bottom: 12px;
}
.address-field-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.info-icon {
  margin-left: 8px;
  cursor: pointer;
  color: #1890ff;
}
/*# sourceMappingURL=lead-details-address.component-SBSFSZHH.css.map */
